import { render, staticRenderFns } from "./shortVideoCommerce.vue?vue&type=template&id=4f2021ea&scoped=true"
import script from "./shortVideoCommerce.vue?vue&type=script&lang=js"
export * from "./shortVideoCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2021ea",
  null
  
)

export default component.exports